import React from 'react';
import './Services.css';

function Services() {
  const servicesData = [
    {
      id: 1,
      category: "Sınav",
      symbol: "➗", // Şık matematik/eğitim sembolleri
      title: "BİLSEM & YKS & LGS Hazırlık",
      description: "Sınav müfredatına tam uyumlu, <span class='text-highlight'>yeni nesil sorularla</span> nokta atışı çalışma programı."
    },
    {
      id: 2,
      category: "Destek",
      symbol: "📈",
      title: "Ara Sınıf Takviye",
      description: "Okul derslerine paralel ilerleyen, <span class='text-highlight'>temeli sağlamlaştıran</span> ve notları yükselten özel dersler."
    },
    {
      id: 3,
      category: "Teknik",
      symbol: "⚡",
      title: "Yeni Nesil Soru Çözümü",
      description: "Ezberden uzak, <span class='text-highlight'>mantık ve muhakeme</span> yeteneğini geliştiren analitik çözüm teknikleri."
    },
    {
      id: 4,
      category: "Rehberlik",
      symbol: "🎯",
      title: "Eğitim Koçluğu",
      description: "Sadece ders anlatmakla kalmaz, öğrencinin <span class='text-highlight'>stres yönetimi</span> ve çalışma planını da takip ederiz."
    }
  ];

  return (
    <section className="services-section" id="hizmetler">
      <div className="services-header">
        <span className="section-subtitle">HİZMETLERİMİZ</span>
        <h2>Neden Turan Hoca?</h2>
        <p>Matematiği korkulu rüya olmaktan çıkaran profesyonel sistem</p>
      </div>
      
      <div className="cards-container">
        {servicesData.map((service) => (
          <div className="service-card" key={service.id}>
            
            {/* Kartın Üst Kısmı: İkon ve Kategori */}
            <div className="card-top">
              <div className="card-icon-box">
                <span className="card-symbol">{service.symbol}</span>
              </div>
              <span className="category-tag">{service.category}</span>
            </div>
            
            {/* Kart İçeriği */}
            <div className="card-content">
              <h3>{service.title}</h3>
              {/* dangerouslySetInnerHTML ile içindeki <span> etiketlerini HTML olarak render ediyoruz */}
              <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
            </div>

            {/* Üzerine gelince dolacak arka plan efekti */}
            <div className="card-hover-bg"></div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;